import { RootState } from "store/store";
import { NotificationResource } from "models/Resources/NotificationResource";

export const selectNotificationsList = (
  state: RootState
): NotificationResource[] => state.gridEventSlice.notificationsList;

export const selectNotificationById = (notificationId: string) => {
  return (state: RootState): NotificationResource | undefined => {
    return selectNotificationsList(state).find(
      n => n.notificationId === notificationId
    );
  };
};
